import { NoticeExtractorPartyResponseDto } from 'app/API';
import { DataRows } from '../DataRows';

type TProps = {
  parties?: NoticeExtractorPartyResponseDto[];
};

export function PartiesCard({ parties = [] }: TProps) {
  return (
    <section className="col-span-full min-w-0 rounded-[10px] border border-border bg-surface p-3.5">
      <h3 className="mb-2.5 text-sm font-bold leading-5 text-foreground">Parties</h3>
      {parties.length ? (
        <div className="grid gap-2.5">
          {parties.map((party, index) => (
            <div
              className="rounded-lg border border-border bg-surface-muted p-2.5"
              key={`${party.name ?? 'party'}-${index}`}
            >
              <DataRows
                rows={[
                  { label: 'Name', value: party.name },
                  { label: 'Role', value: party.role },
                  { label: 'Represented by', value: party.represented_by },
                ]}
              />
            </div>
          ))}
        </div>
      ) : (
        <span className="text-xs leading-[18px] text-foreground-muted">No parties found</span>
      )}
    </section>
  );
}
